import React from 'react';
import { Link } from 'react-router-dom';
import { FaExternalLinkAlt } from 'react-icons/fa';
import Card from '../../components/Card/Card';
import { toIdentifierMask } from '../../services/mask';
import InvoiceStatusBadge from '../../components/InvoiceStatus/InvoiceStatusBadge';
import { InvoiceViewModel } from '../../models/Invoice/InvoiceViewModel';

interface InvoiceCardParams {
  isLoading: boolean;
  invoices: InvoiceViewModel[];
  header: string;
}

export default function InvoiceCard({
  isLoading,
  invoices,
  header,
}: InvoiceCardParams) {
  return (
    <Card header={header} isLoading={isLoading}>
      <ul className='list-group list-group-flush'>
        {invoices.map((i) => {
          const createdAt = new Date(i.createdAt);
          return (
            <li
              key={i.id}
              className='list-group-item d-flex justify-content-between gap-2 '
            >
              <div className='d-flex gap-2'>
                <div>
                  <InvoiceStatusBadge
                    state={i.statusState}
                    label={i.statusLabel}
                  />
                  <div>
                    {i.number && (
                      <small className='text-muted'>#{i.number}</small>
                    )}
                  </div>
                  <div>{createdAt.toLocaleDateString()}</div>
                </div>
                <div>
                  <div>
                    <span>{i.customerName}</span>
                  </div>
                  <small className='text-muted'>
                    {toIdentifierMask(i.companyIdentifier, i.companyType)}
                  </small>
                </div>
              </div>
              <div>
                <Link to={`/invoices/${i.id}/edit`} target='_blank'>
                  <FaExternalLinkAlt />
                </Link>
              </div>
            </li>
          );
        })}
        {invoices.length === 0 && (
          <div>
            <span>Nenhum registro</span>
          </div>
        )}
      </ul>
    </Card>
  );
}
